import React, { useEffect, useState } from 'react';
import "./RecordFormMain.scss"

import { dateFromDDMMYYYYtoYYYYMMDD } from '../../../../helpers/datetime';

import RecordFormClinics from '../RecordFormClinics/RecordFormClinics';
import RecordFormServices from '../RecordFormServices/RecordFormServices';
import Input from '../../../UI/Input/Input';
import RecordFormDate from '../RecordFormDate/RecordFormDate';
import Textarea from '../../../UI/Textarea/Textarea';

import PostService from '../../../../API/PostService';
import { useFetching } from '../../../../hooks/useFetching';
import { setRecordsAction } from '../../../../store/recordsTableReducer';
import { useSelector, useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import DropdownSmall from '../../../UI/DropdownSmall/DropdownSmall';

const RecordFormMain = ({id = null, callbackFunction = null, record = null}) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const clinic = useSelector(state => state.recordsTable.clinic)
	const period = useSelector(state => state.recordsTable.period)

	const [config, setConfig] = useState({});
	const [enableFinish, setEnableFinish] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [canEdit, setCanEdit] = useState(false);
	const [edited, setEdited] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		setTimeout(() => {
			setCanEdit(true)
		}, 500);
	},[])

	const selectedHandlerClinics = (id) => {
		let newConfig = {...config, clinic: id}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const selectedHandlerServices = (id) => {
		let newConfig = {...config, service: id}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveNameValue = (value) => {
		let newConfig = {...config, name: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveLastNameValue = (value) => {
		let newConfig = {...config, last_name: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recievePhoneValue = (value) => {
		let newConfig = {...config, phone: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveEmailValue = (value) => {
		let newConfig = {...config, email: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveBirthDateValue = (value) => {
		let newConfig = {...config, birth_date: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveDateValue = (value) => {
		let newConfig = {...config, date: dateFromDDMMYYYYtoYYYYMMDD(value)}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveTimeValue = (value) => {
		let newConfig = {...config, time: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveCommentValue = (value) => {
		let newConfig = {...config, comment: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveAdminCommentValue = (value) => {
		let newConfig = {...config, admin_comment: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const recieveStatusChange = (value) => {
		let newConfig = {...config, status: value}
		checkEnableFinish(newConfig, config)
		setConfig(newConfig)
	}

	const checkEnableFinish = (config, oldConfig) => {
		if((JSON.stringify(config) !== JSON.stringify(oldConfig)) && canEdit){
			setEdited(true)
		}

		let enable = true;
		if(!config.name || config.name === '') enable = false;
		if(!config.last_name || config.last_name === '') enable = false;
		if(!config.phone || config.phone === '' || config.phone.length !== 18) enable = false;
		// if(!config.email || config.email === '') enable = false;
		if(!config.time || config.time === '') enable = false;
		if(!config.date || config.date === '') enable = false;
		if(!config.clinic) enable = false;
		if(!config.service) enable = false;

		setEnableFinish(enable)
	}

	const submitRecord = () => {
		if(enableFinish) fetchAddRecord(config)
	}

	const [fetchAddRecord] = useFetching(async (data) => {
		setError('')
		setEnableFinish(false)
		const response = await PostService.addRecord(data)
		if (response.data.success) {
			setEnableFinish(true)
			fetchRecords(clinic, period)
			if(callbackFunction){
				callbackFunction()
			} else {
				navigate('/');
			}
		} else if(response.data.result !== false){
			if(typeof response.data.result === 'string') setError(response.data.result);
		}
	})

	const [fetchRecords] = useFetching(async (clinic, period) => {
		const response = await PostService.getRecordsByPeriod(clinic, period)
		if (response.data.success && response.data.result !== false) {
			dispatch(setRecordsAction(response.data.result))
		}
	})

	const saveChanges = () => {
		fetchUpdateRecord(id, config);
	}

	const [fetchUpdateRecord] = useFetching(async (recordId, data) => {
		setError('')
		const response = await PostService.updateRecord(recordId, data)
		if (response.data.success && response.data.result !== false) {
			fetchRecords(clinic, period)
			if(callbackFunction){
				callbackFunction()
			} else {
				navigate('/');
			}
		}
	})

	const deleteRecord = () => {
		fetchUpdateRecord(id, {deleted: 1});
	}

	return (
		<div className="record-form">
			{
				!confirmDelete &&
				<>
				<div className="record-form__headline">
					<h3>{id ? `Запись №${id}` : 'Новая запись'}</h3>
					{
						record?.status &&
						<DropdownSmall optionsList={record.statuses} optionSelected={record.status} selectedHandler={recieveStatusChange}/>
					}
				</div>
				{
					record &&
					<div className='record-form__info'>
						{record.source?.value &&
							<div className="record-form__info-item"><span>Источник: </span>{record.source.value}</div>
						}
						{record.date_create_formated &&
							<div className="record-form__info-item"><span>Создана: </span>{record.date_create_formated}</div>
						}
					</div>
				}
				<RecordFormServices selectHandler={selectedHandlerServices} selectedService={record?.service?.id ? record.service.id : null}/>
				<RecordFormClinics selectHandler={selectedHandlerClinics} selectedClinic={record?.clinic?.id ? record.clinic.id : null}/>
				<div className="record-form__date">
					<RecordFormDate newRecord={!id} dateInputHandler={recieveDateValue} timeInputHandler={recieveTimeValue} selectedRecord={record} config={config}/>
				</div>
				<div className='record-form__group'>
					<div className="record-form__group-item">
						<Input label='Имя' inputHandler={recieveNameValue} defaultValue={record ? record?.name : ''}/>
					</div>
					<div className="record-form__group-item">
						<Input label='Фамилия' inputHandler={recieveLastNameValue} defaultValue={record ? record?.last_name : ''}/>
					</div>
				</div>
				<div className="record-form__input">
					<Input label='Дата рождения' inputHandler={recieveBirthDateValue} type='date_birth' defaultValue={record ? record?.birth_date_formated : ''}/>
				</div>
				<div className='record-form__group'>
					<div className="record-form__group-item">
						<Input label='Телефон' inputHandler={recievePhoneValue} type='phone' defaultValue={record ? record?.phone : ''}/>
					</div>
					<div className="record-form__group-item">
						<Input label='E-mail' inputHandler={recieveEmailValue} defaultValue={record ? record?.email : ''}/>
					</div>
				</div>
				<div className="record-form__comment">
					<Textarea
						placeholder='Комментарий клиента'
						onChange={recieveCommentValue}
						defaultValue={record ? record?.comment : ''}
						defaultHeight={76}/>
				</div>
				<div className="record-form__comment">
					<Textarea
						placeholder='Комментарий администратора (не видит пользователь)'
						onChange={recieveAdminCommentValue}
						defaultValue={record ? record?.admin_comment : ''}
						defaultHeight={76}/>
				</div>
				<div className="record-form__submit">
					{!id &&
						<button className='g-button' disabled={!enableFinish} onClick={submitRecord}>Добавить запись</button>
					}
					{record &&
					<>
						<button className={edited ? 'g-button' : 'g-button-secondary'} onClick={saveChanges}>Сохранить</button>
						<button className='g-button-link' onClick={() => setConfirmDelete(true)}>Удалить запись</button>
					</>
					}
				</div>
				{error !== '' &&
					<div className="record-form__error">{error}</div>
				}
				</>
			}
			{
				confirmDelete &&
				<>
				<div className="record-form__headline">
					<h3>Подтверждение</h3>
				</div>
				<div className="record-form__description">
					Вы действительно хотите удалить запись?
				</div>
				<div className="record-form__btns">
					<button className='g-button' onClick={deleteRecord}>Удалить</button>
					<button className='g-button-secondary' onClick={() => setConfirmDelete(false)}>Отменить</button>
				</div>
				</>
			}
		</div>
	);
};

export default RecordFormMain;
